import { render, staticRenderFns } from "./select-worker.vue?vue&type=template&id=25d562d2&"
import script from "./select-worker.vue?vue&type=script&lang=js&"
export * from "./select-worker.vue?vue&type=script&lang=js&"
import style0 from "./select-worker.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports